// eslint-disable-next-line import/no-cycle
import { getCurrentProductPropertiesSegments } from './currentProductPropertiesSegment';
// eslint-disable-next-line import/no-cycle
import { getCurrentCategoryPropertiesSegments } from './currentCategoryPropertiesSegment';
// eslint-disable-next-line import/no-cycle
import { getCurrentManufacturerPropertiesSegments } from './currentManufacturerPropertiesSegment';
// eslint-disable-next-line import/no-cycle
import { getCurrentPagePropertiesSegments } from './currentPagePropertiesSegment';

/**
 * Get the navigation context segments
 * These segments are evaluated against the current page's navigation context
 * (current product, category, manufacturer, page URL)
 */
export const getNavigationContextSegments = async (includeContext = false) => {
  const currentProductProperties = await getCurrentProductPropertiesSegments(includeContext);
  const currentCategoryProperties = getCurrentCategoryPropertiesSegments(includeContext);
  const currentManufacturerProperties = getCurrentManufacturerPropertiesSegments(includeContext);
  const currentPageProperties = getCurrentPagePropertiesSegments(includeContext);

  return {
    id: 'navigationContext',
    list: [
      {
        id: 'currentProduct',
        label: 'segmentations.navigation.currentProduct.title',
        sub_properties: currentProductProperties,
      },
      {
        id: 'currentCategory',
        label: 'segmentations.navigation.currentCategory.title',
        sub_properties: currentCategoryProperties,
      },
      {
        id: 'currentManufacturer',
        label: 'segmentations.navigation.currentManufacturer.title',
        sub_properties: currentManufacturerProperties,
      },
      {
        id: 'currentPage',
        label: 'segmentations.navigation.currentPage.title',
        sub_properties: currentPageProperties,
      },
    ],
  };
};

export default getNavigationContextSegments;
